import { Link } from "react-router-dom";
import { getSalmoDoDia, getTitulo, getTexto } from "@/lib/salmos";
import { useLang } from "@/lib/i18n";
import OrnamentoDourado from "./OrnamentoDourado";

export default function SalmoDoDia() {
  const salmo = getSalmoDoDia();
  const { lang, t } = useLang();
  const titulo = getTitulo(salmo, lang);
  const texto = getTexto(salmo, lang);
  const primeiraFrase = (texto.split(/[.!?]/)[0] || texto.slice(0, 200)).trim();

  return (
    <div
      className="relative mx-auto max-w-3xl rounded-sm border border-[var(--cor-dourado)]/30 bg-[var(--cor-fundo-2)]/70 p-10 md:p-14 backdrop-blur-md shadow-[0_0_60px_rgba(201,169,110,0.08)]"
      data-testid="salmo-do-dia"
    >
      <div className="font-display text-[10px] uppercase tracking-[0.32em] text-[var(--cor-dourado)] text-center">
        {t.salmo_do_dia}
      </div>
      <OrnamentoDourado className="mt-5" />
      <div className="mt-8 text-center">
        <div className="font-display text-7xl md:text-8xl text-[var(--cor-dourado)] font-light leading-none">
          {salmo.numero}
        </div>
        <h2 className="font-display text-3xl md:text-4xl text-[var(--cor-texto)] mt-5 font-light tracking-wide">
          {titulo}
        </h2>
      </div>
      <p className="font-serif text-[var(--cor-texto-2)] mt-8 leading-[2] text-lg italic text-center max-w-2xl mx-auto">
        "{primeiraFrase}."
      </p>
      <div className="mt-10 text-center">
        <Link
          to={`/salmo/${salmo.numero}`}
          className="inline-block font-display text-sm uppercase tracking-[0.28em] text-[var(--cor-dourado)] border border-[var(--cor-dourado)]/40 px-10 py-4 rounded-full hover:bg-[var(--cor-dourado)]/10 hover:border-[var(--cor-dourado)] hover:text-[var(--cor-dourado-claro)] transition-all duration-500"
          data-testid="ler-salmo-completo-btn"
        >
          {t.ler_completo}
        </Link>
      </div>
    </div>
  );
}
